import { IGetFuncionariosTercDropDownUseCase } from "../../../presentation/useCases/read/get_funcionarios_terc_drop_down_use_case";
import { FuncionarioTercDropDown } from "../../models/funcionario_terc_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";


export class GetFuncionariosTercDropDownUseCase implements IGetFuncionariosTercDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getFuncionariosTercDropDown(
    filtrarCentroCusto?: boolean,
    idFornecedor?: number
  ): Promise<FuncionarioTercDropDown[]> {
    return await this.repository.getFuncionariosTercDropDown(
      filtrarCentroCusto ?? null,
      idFornecedor 
    );
  }
}
